import { Pipe, PipeTransform } from '@angular/core';
import {CommonModule} from "@angular/common";

@Pipe({
  name: 'stripSpecialChars',
  standalone: true
})
export class StripSpecialCharsPipe implements PipeTransform {

  public static strip(value: any, args?: any) {
    return value ? value
      .toString().
      toLowerCase().
      trim().
      replace(/&/g, '-and-')
      .replace(/[\s\W-]+/g, '-') : '';
  }

  transform(value: any, args?: any): any {
    return StripSpecialCharsPipe.strip(value, args);
  }

}
